import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["digit", "form", "submit"];

  connect() {
    // Focus the first input on page load
    this.digitTargets[0]?.focus();
  }

  handleInput(event) {
    const input = event.target;
    const value = input.value;
    const index = parseInt(input.dataset.index);

    // Only allow single digits
    if (!/^\d$/.test(value)) {
      input.value = "";
      return;
    }

    // Auto-advance to next input
    if (value && index < 5) {
      this.digitTargets[index + 1].focus();
    }

    // Auto-submit when all 6 digits are filled
    if (this.allDigitsFilled()) {
      this.formTarget.requestSubmit();
    }
  }

  handleKeydown(event) {
    const input = event.target;
    const index = parseInt(input.dataset.index);

    if (event.key === "Backspace") {
      if (input.value === "" && index > 0) {
        // Move to previous input and clear it
        const prevInput = this.digitTargets[index - 1];
        prevInput.value = "";
        prevInput.focus();
        event.preventDefault();
      }
    } else if (event.key === "ArrowLeft" && index > 0) {
      this.digitTargets[index - 1].focus();
      event.preventDefault();
    } else if (event.key === "ArrowRight" && index < 5) {
      this.digitTargets[index + 1].focus();
      event.preventDefault();
    }
  }

  handlePaste(event) {
    event.preventDefault();
    const pastedData = (event.clipboardData || window.clipboardData)
      .getData("text")
      .trim();

    // Extract only digits
    const digits = pastedData.replace(/\D/g, "").slice(0, 6);

    if (digits.length === 0) return;

    // Distribute digits across inputs
    digits.split("").forEach((digit, i) => {
      if (this.digitTargets[i]) {
        this.digitTargets[i].value = digit;
      }
    });

    // Focus the next empty input or the last one
    const nextEmpty = this.digitTargets.findIndex((input) => !input.value);
    if (nextEmpty !== -1) {
      this.digitTargets[nextEmpty].focus();
    } else {
      this.digitTargets[5].focus();
    }

    // Auto-submit if all digits are filled
    if (this.allDigitsFilled()) {
      this.formTarget.requestSubmit();
    }
  }

  allDigitsFilled() {
    return this.digitTargets.every((input) => /^\d$/.test(input.value));
  }
}
